import CommonModal from '../common/modal/CommonModal'

interface IExitTypeTestConfirmModalProps {
  onExit: () => void
  onClose: () => void
}

const ExitTypeTestConfirmModal = ({ onExit, onClose }: IExitTypeTestConfirmModalProps) => {
  return (
    <CommonModal
      onClose={onExit}
      title={
        <div>
          <p>종료하시겠습니까?</p>
          <p>검사가 완료되지 않았습니다. 종료 시 진행 과정은 저장되지 않습니다.</p>
        </div>
      }
      topButtonText='네'
      topButtonOnClick={onExit}
      bottomButtonText='취소'
      bottomButtonOnClick={onClose}
    />
  )
}

export default ExitTypeTestConfirmModal
